const theme = {
  color: {
    textPrimary: '#4d4d4d',
    textSecondary: '#fff',
    bgDark: '#4d4d4d',
    bgLight: '#e2e2e2',
    bgYellow: '#fca317',
    bgMedium: '#999999',
    hoverPrimary: '#fca317',
    hoverSecondary: '#e2e2e2',
    inputPrimary: '#f3f3f3',
    borderPrimary: '#4d4d4d',
    borderSecondary: '#fca317'
  },
  fontSize: {
    desktop: {
      h1: '60px', // 60px
      h2: '48px', // 48px
      h3: '36px', // 36px
      h4: '28px', // 28px
      h5: '24px', // 25px
      body: '16px', // 16px
      small: '12px',
      large: '100px'
    },
    mobile: {
      h1: '32px',
      h2: '28px',
      h3: '24px',
      h4: '22px',
      h5: '20px',
      body: '16px',
      small: '12px',
      smaller: '10px',
      large: '32px'
    }
  },
  screen: {
    desktop: '1920px',
    mobile: '480px'
  },
  lineHeight: {
    large: '1.5em',
    medium: '1.125em',
    small: '0.875em'
  }
}

export default theme



// WEBPACK FOOTER //
// ./src/utils/theme.js